export const villages = [
    'Bugole "A"',
    'Bugole "B"',
    'Bugongo A',
    'Namabwere I',
    'Namabwere II',
    'Namukumya',
    'Nawandala',
    'Nwangaiza 2',
    'Busakaire',
    'Bugongo B',
    'Kiwanyi I',
    'Kiwanyi II',
    'Busaala',
    'Buwumba',
    'Madhimasu',
    'Bukyeega',
    'Bugambo',
    'Bunyokano',
    'Busoigi',
    'Buzaya',
    'Ikumbya',
    'Kabuli I',
    'Kabuli II',
    'Kyendabawala',
    'Buyunga',
    'Malobi A',
    'Malobi B',
    'Namusiisi',
    'Buganza',
    'Kiringa "A"',
    'Kiringa "B"',
    'Nawandgaiza 1',
];

export const carriers = [
    "MTN",
    "Airtel",
    "Africell",
    "UTL",
    "Smile",
    "K2",
];

export const phone_owner = [
    "RESPONDENTS",
    "SPOUSE'S PHONE",
    "OTHER FAMILY MEMBER",
    "NEIGHBOR",
];

export const number_anc = [
    "ONE VISIT",
    "TWO VISITS",
    "THREE VISITS",
    "FOUR OR MORE VISITS",
];

export const place_deliver = [
    "HEALTH CENTER",
    "HOSPITAL",
    "PRIVATE CLINIC",
    "HOME",
    "DRUG SHOP",
    "TRADITIONAL",
];

export const transport_type = [
    "WALKING",
    "BICYCLE TAXI",
    "MOTORCYCLE TAXI",
    "MATATU",
    "BICYCLE MY HOUSEHOLD OWNS",
    "MOTORCYCLE MY HOUSEHOLD OWNS",
    "AUTOCAR MY HOUSEHOLD OWNS",
    "SAFE MOTORCYCLE AMBULANCE",
];

export const supplies_items = [
    "mama_kit",
    "mackintosh",
    "razor",
    "pad",
    "cotton",
    "soap",
    "gloves",
    "medication",
    'baby_clothes',
    'blanket',
    'sheets',
];

export const education = [
    "SOME PRIMARY",
    "PRIMARY",
    "SOME SECONDARY",
    "SECONDARY",
    "UNIVERSITY OR HIGHER"
];

export const decision_maker = [
    "RESPONDENT",
    "SPOUSE PARTNER",
    "JOINT"
];

export const marital_status = [
    "NEVER MARRIED/ NO COHABITATION",
    "CURRENTLY MARRIED",
    "COHABITATION",
    "MARRIED BUT SEPARATED",
    "DIVORCED",
    'WIDOWED',
];

export const wives_number = [
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
];

export const wife_rank = [
    'FIRST WIFE',
    'SECOND WIFE',
    'THIRD WIFE',
    'FOURTH WIFE',
];

export const insurance = [
    'COMMUNITY-BASED HEALTH INSURANCE',
    'PRIVATE COMMERCIAL HEALTH INSURANCE'
];

export const notes = {
    pregnancy: "Are you currently pregnant?",
    due_date: "Is your due date in the next month?",
    deliver_elsewhere: "Has a doctor midwife told you that you should deliver this baby in Bugono HC IV or the Iganga Hospital?",
    hx_cesarean: "Have you ever had a cesarean section?",
    hx_complication: "If you have given birth before, did you experience any complications during delivery or problems that required emergent medical treatment at a health centre?",
    current_multip: "Are you currently pregnant with more than one baby, that is with twins or triplets?",

    obstructed_labor: "Obstructed labor, that is, being told that the baby was stuck in the birth canal and needed help from a medical provider to be removed.",
    malpresent: "Malpresentation, that is, when a part other than the baby's head faces down during labor and delivery.",
    aph: "Antepartum hemorrhage, that is, excessive bleeding before the birth of a baby",
    pph: "Postpartum hemorrhage, that is, excessive bleeding after the birth of a baby",
    ret_placenta: "Retained placenta, that is, where a piece of the placenta remains inside the uterus and must be removed by a medical provider",
    placenta_previa: "Placenta previa, where the placenta sits in between the baby's body and the opening where the baby comes out",
    hx_stillbirth: "Have you ever had a stillbirth, that is where the baby was born not alive?",
    no_stillbirths: "How many stillbirths have you had?",
    other_complication: "Have you been told that you had any other complications in any pregnancy that I have not asked you about?",
    no_anc: "How many antenatal care visits have you had during this pregnancy?",
    deliver_place: "In what location would you like to deliver this baby?",
    deliver_specific: "What is the name of the specific health facility where you would like to deliver your baby?",
    deliver_place_other: "SPECIFY PLACE OF DELIVERY (OTHER)",
    plan_transport: "Before today, how did you expect to reach this location, that is what type of transport would you likely use?",
    purchase_supplies: "Have you purchased any supplies in preparation for the birth of this baby?",
    saving_money: "Have you saved any money to use for expenses related to this pregnancy or birth, such as supplies, transport, or emergencies?",
    attend_school: "Have you ever attended school?",
    education: "What is the highest level of school you completed?",
    money_control: "Who usually decides how the money you earn will be used: you, your (SPOUSE/PARTNER), you and your (SPOUSE/PARTNER) jointly, or someone else?",
    total_house: "How many people live in your household, that is, how many people do you share your meals with on a daily basis?",
    marital_status: "What is your marital status?",
    spouse_school: "Did your (CURRENT/LAST) (HUSBAND/PARTNER) ever attend school?",
    spouse_education: "What is the highest level of school your partner completed?",
    polygamy: "Does/did your (HUSBAND/PARTNER) have other wives or does he live with other women as if married?",
    no_wives: "Including yourself, how many wives or live-with partners does/did your (HUSBAND/PARTNER) have?",
    no_wives_other: "SPECIFY NUMBER OF WIVES/LIVE-WITH PARTNERS",
    wife_order: "Are/were you the first, second…. wife/live-in partner?",
    wife_order_other: "TYPE THE ORDER. FOR EXAMPLE, IF THE RESPONDENT WAS THE FIFTH OF SIX WIVES, YOU WOULD TYPE 'FIFTH'.",
    insurance: "Do you have any type of health insurance?",
    insurance_type: "What type of health insurance do you have?",

    no_pg: "Over the course of your lifetime, how many times have you been pregnant, including this pregnancy? including any miscarriages, stillbirths, and children that were born alive but later died.",
    no_birth: "How many times have you given birth? including any miscarriages, stillbirths, and children that were born alive but later died.",
    no_children: "How many living children do you have?",
    no_under5: "How many children are living in your home who are under the age of five years?",
    hx_childdeath: "Have you ever given birth to a child who was born alive but later died?",
    no_childdeath: "How many of your children were born alive but later died?",

};



